module.exports = __webpack_public_path__ + "static/media/cuboColors.e3db889b.gif";